<div class="d-flex flex-column justify-content-between h-100">
  <app-navbar></app-navbar>
  <div>
    <router-outlet></router-outlet>
  </div>
  <app-bottom-navbar></app-bottom-navbar>
</div>

